var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdeaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3000,
    height: 3000,
    viewBox: "0 0 3000 3000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1511 59.5C2051.85 65.6695 2475.94 524.258 2463.5 1065C2457.51 1325.36 2372 1516.5 2223 1687C2074 1857.5 1926 1981.5 1926 2194C1926 2406.5 1926 2714.5 1926 2714.5L1614 2932H1503M1511 59.5C964.207 53.2627 522.05 518.362 536.501 1065C543.398 1325.91 603.501 1515.5 781.001 1687C958.5 1858.5 1059 2048 1059 2194C1059 2340 1059 2714.5 1059 2714.5L1392 2932H1503M1511 59.5L1503 2932",
    stroke: "#00FF66",
    strokeWidth: 85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1926 2714.5L1614 2932H1503L1511 59.5C2051.85 65.6695 2475.94 524.258 2463.5 1065C2457.51 1325.36 2372 1516.5 2223 1687C2074 1857.5 1926 1981.5 1926 2194V2714.5Z",
    fill: "#00FF66",
    stroke: "#00FF66",
    strokeWidth: 85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaLogo);
export default __webpack_public_path__ + "static/media/idea_logo.a6f92c3b9a64b128f0380feb92e4b179.svg";
export { ForwardRef as ReactComponent };